// Hooks
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';

// Utils
import useTranslation from 'next-translate/useTranslation';

// Components
import Icon from '@/components/base/Icon';
import Button from '@/components/base/Button';

// Types
import type { ButtonProps } from '@/components/base/Button';
import type { ModalProps } from '@/components/base/Modal';

export type AlbumsCreateButtonProps = Pick<ButtonProps, 'size'> & {
    onClick: ModalProps['onDismiss'];
};

const AlbumsCreateButton = ({ size = 'md', onClick }: AlbumsCreateButtonProps) => {
    const { t } = useTranslation();
    const { isTreeStructureActivated } = useActiveTreeStructure();

    return (
        <div className="w-full md:w-52">
            <Button
                className="create-new-add w-full space-x-2 md:w-52"
                size={size}
                onClick={onClick}>
                <Icon icon={isTreeStructureActivated ? 'plus-border' : 'plus'} />
                <span>{t('content:create_album')}</span>
            </Button>
        </div>
    );
};

export default AlbumsCreateButton;
